export const generateRandomString = (length = 32) => {
  const bytes = new Uint8Array(length);
  const result = [];
  const charset =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';

  // @ts-expect-error -- msCrypto is IE-only and not in standard lib typedefs
  const crypto = window.crypto || window.msCrypto;
  const random = crypto?.getRandomValues(bytes) || [];
  for (const el of random) {
    result.push(charset[el % charset.length]);
  }

  return result.join('');
};
